// extracted by mini-css-extract-plugin
export var box = "_4g-0";
export var check = "_4g-1";
export var checkboxButton = "_4g-6";
export var checkboxGroup = "_4g-5";
export var disabled = "_4g-7";
export var ghost = "_4g-9";
export var input = "_4g-2";
export var label = "_4g-4";
export var normal = "_4g-8";
export var uncheck = "_4g-3";